import s from './TaskCard.module.scss';
import React from "react";
import {TTaskCardProps} from "@/app/[locale]/common/components/TaskCard/types";

export const TaskCard = ({ Icon, title }: TTaskCardProps) => {
    return (
        <div className={s.card}>
            <div className={s.card_iconContainer}>
                <Icon/>
            </div>
            <p>{title}</p>
        </div>
    );
};